import { render, staticRenderFns } from "./PageHeaderProducts.vue?vue&type=template&id=62c2deba"
import script from "./PageHeaderProducts.vue?vue&type=script&lang=js"
export * from "./PageHeaderProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports